import { render, staticRenderFns } from "./multi-choice-translated-option.vue?vue&type=template&id=ac7a1e30&"
import script from "./multi-choice-translated-option.vue?vue&type=script&lang=js&"
export * from "./multi-choice-translated-option.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "multi-choice-translated-option.vue"
export default component.exports